export const formatPrice = (priceInDollars: number) => {
  if (typeof priceInDollars !== 'number') return null;
  return `$${priceInDollars.toFixed(2)}`;
};
